import styles from '../BundleSummaryCard.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { CONNECT_TO_SALES_PATH } from 'src/components/App/Routes/Routes';
import { useFeatureFlagsContext } from 'src/components/FeatureFlags/FeatureFlags';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { BundlePricings } from 'src/hooks/useDCS';
import { shouldDisplayInstallmentPlans } from 'src/services/dcs/bundle';

interface BundleSummaryCardPriceProps {
  pricings?: BundlePricings;
}

export const BundleSummaryCardPrice: React.FC<BundleSummaryCardPriceProps> = ({ pricings }) => {
  const { t } = useTranslation();
  const { isFlagEnabled } = useFeatureFlagsContext();
  const isMsrpEnabled = isFlagEnabled('show-msrp-global');

  if (!pricings) {
    return (
      <Link to={CONNECT_TO_SALES_PATH} className={styles.contactSalesForPricing}>
        {t('bundle-summary-card.contact-sales-for-pricing')}
      </Link>
    );
  }

  return (
    <div className={styles.bundleSummaryCardPrices}>
      {isMsrpEnabled && pricings.msrp && (
        <TextV2
          value={t('bundle-summary-card.msrp', { price: pricings.msrp.value })}
          className={styles.bundleSummaryCardMsrp}
          aria-label={`MSRP ${t('bundle-summary-card.msrp', { price: pricings.msrp.value })}`}
          data-test="msrp-pricing"
        />
      )}
      <div className={styles.bundleSummaryCardPrice}>
        <TextV2
          variant="h3-bold"
          value={t('bundle-summary-card.full-price', { basePrice: pricings.basePrice.value })}
          className={styles.bundleSummaryCardFullPrice}
        />

        {shouldDisplayInstallmentPlans(pricings.basePrice.value) && pricings.installmentPlans?.IP3 && (
          <TextV2
            variant="h5-bold"
            value={t('bundle-summary-card.three-month-price', { price: pricings.installmentPlans.IP3.value })}
            className={styles.bundleSummaryCardInstallmentPrice}
          />
        )}
      </div>
      <h4 className={styles.bundleSummaryCardMonthlyPrice}>
        <TextV2
          variant="h5-bold"
          value={t('bundle-summary-card.monthly-price', { monthlyPrice: pricings.monthlyAdditionalPrice.value })}
        />
      </h4>
    </div>
  );
};

BundleSummaryCardPrice.displayName = 'BundleSummaryCardPrice';
